@if (isModalOpen()) { @if(header() || closeButtonEnabled() || headerIcon()){
<div class="tw-fixed tw-top-0 tw-start-0 tw-z-[1500] tw-w-screen tw-h-screen tw-bg-black/50 tw-flex tw-justify-center tw-items-center tw-py-1" (click)="onBackdropClick($event)">
  <div
    class="tw-bg-white dark:tw-bg-gray-800 tw-relative tw-border tw-border-gray-200 dark:tw-border-gray-800 tw-overflow-hidden tw-flex tw-flex-col tw-mx-4 lg:tw-mx-0 {{
      roundedClass()
    }}"
    [ngClass]="[
      widthClass() ? widthClass() : 'tw-w-11/12 md:tw-w-3/4 lg:tw-w-3/4 xl:tw-w-8/12 tw-max-w-xl',
      heightClass() ? heightClass() : 'tw-h-3/4 md:tw-h-3/4 lg:tw-h-3/4 xl:tw-h-8/12'
    ]"
    [id]="id()"
    [@child]
    (click)="onModalContentClick($event)"
  >
    @if(showHeader()){
    <div
      class="tw-py-4 tw-px-6 tw-flex tw-items-center tw-justify-between"
      [ngClass]="{
        'tw-border-b tw-border-solid tw-border-gray-200 dark:tw-border-gray-600': showHeaderDivider()
      }"
    >
      <div class="tw-flex tw-items-center tw-gap-4">
        @if (headerIcon()) {
        <span [innerHTML]="headerIcon() | safe"></span>
        }
        <p class="tw-text-gray-900 dark:tw-text-gray-100 tw-text-base tw-font-semibold tw-leading-6 md:tw-text-lg md:tw-font-semibold tw-font-inter md:tw-leading-7">
          {{ header() | translate }}
        </p>
        <!-- Switch -->
        @if (headerSwitch() && switchControl()) {
        <label class="tw-inline-flex tw-items-center tw-cursor-pointer">
          <input type="checkbox" [formControl]="switchControl()" class="tw-sr-only tw-peer" (change)="switchChange($event)" />
          <div
            class="tw-relative tw-w-14 tw-h-7 tw-bg-gray-200 tw-peer-focus:tw-outline-none tw-rounded-full tw-peer tw-peer-checked:tw-after:tw-translate-x-full tw-peer-checked:tw-after:tw-border-white tw-after:tw-content-[''] tw-after:tw-absolute tw-after:tw-top-[3px] tw-after:tw-start-[3px] tw-peer-checked:tw-after:tw-start-[8px] tw-after:tw-bg-white tw-after:tw-border-gray-300 tw-after:tw-border tw-after:tw-rounded-full tw-after:tw-w-[22px] tw-after:tw-h-[22px] tw-after:tw-transition-all tw-peer-checked:tw-bg-blue-600"
          ></div>
        </label>
        }
      </div>
      @if (closeButtonEnabled()) {
      <span (mousedown)="$event.preventDefault(); $event.stopPropagation()" (click)="closeModal()">
        <svg xmlns="http://www.w3.org/2000/svg" class="tw-w-2.5 tw-h-2.5 md:tw-w-3 md:tw-h-3 tw-cursor-pointer" viewBox="0 0 12 12" fill="none">
          <g clip-path="url(#clip0_5530_30649)">
            <path
              d="M7.20988 6L11.7388 1.47109C11.8205 1.39216 11.8857 1.29775 11.9305 1.19336C11.9754 1.08896 11.999 0.976687 12 0.863076C12.001 0.749465 11.9793 0.636794 11.9363 0.531639C11.8933 0.426484 11.8297 0.33095 11.7494 0.250611C11.669 0.170273 11.5735 0.106739 11.4684 0.0637164C11.3632 0.020694 11.2505 -0.000954946 11.1369 3.23065e-05C11.0233 0.00101956 10.911 0.0246235 10.8066 0.0694668C10.7023 0.11431 10.6078 0.179495 10.5289 0.261217L6 4.79012L1.47109 0.261217C1.30972 0.105355 1.09358 0.0191112 0.869234 0.0210607C0.644888 0.0230102 0.430283 0.112997 0.27164 0.27164C0.112997 0.430283 0.0230102 0.644888 0.0210607 0.869234C0.0191112 1.09358 0.105355 1.30972 0.261217 1.47109L4.79012 6L0.261217 10.5289C0.179495 10.6078 0.11431 10.7023 0.0694668 10.8066C0.0246235 10.911 0.00101956 11.0233 3.23065e-05 11.1369C-0.000954946 11.2505 0.020694 11.3632 0.0637164 11.4684C0.106739 11.5735 0.170273 11.669 0.250611 11.7494C0.33095 11.8297 0.426484 11.8933 0.531639 11.9363C0.636794 11.9793 0.749465 12.001 0.863076 12C0.976687 11.999 1.08896 11.9754 1.19336 11.9305C1.29775 11.8857 1.39216 11.8205 1.47109 11.7388L6 7.20988L10.5289 11.7388C10.6903 11.8946 10.9064 11.9809 11.1308 11.9789C11.3551 11.977 11.5697 11.887 11.7284 11.7284C11.887 11.5697 11.977 11.3551 11.9789 11.1308C11.9809 10.9064 11.8946 10.6903 11.7388 10.5289L7.20988 6Z"
              class="tw-fill-gray-400"
            />
          </g>
          <defs>
            <clipPath id="clip0_5530_30649">
              <rect width="12" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </span>
      }
    </div>
    }
    <div class="tw-overflow-y-auto tw-py-4 tw-px-6 tw-flex-1 tw-min-h-0">
      <ng-content select="[slot=body]"></ng-content>
    </div>
    <div
      class="tw-shrink-0"
      [ngClass]="{
        'tw-border-t tw-border-solid tw-border-gray-200': showFooterDivider()
      }"
    >
      <ng-content select="[slot=footer]"></ng-content>
    </div>
  </div>
</div>
} }
